/* ==========================================
   SITE THEME
========================================== */

function getSiteTheme() {

  return (
    document.documentElement
      .dataset.theme ||
    "dark"
  );

}


/* ==========================================
   UPDATE TOGGLE BUTTON
========================================== */

function updateThemeButton(
  button
) {

  const theme =
    getSiteTheme();


  const nextTheme =
    theme === "dark"
      ? "light"
      : "dark";


  const sun =
    button.querySelector(
      "[data-theme-icon-sun]"
    );


  const moon =
    button.querySelector(
      "[data-theme-icon-moon]"
    );


  const label =
    button.querySelector(
      "[data-theme-label]"
    );


  /*
    Icon represents the theme
    clicking will switch TO.

    Dark mode → sun
    Light mode → filled moon
  */

  if (sun) {

    sun.hidden =
      nextTheme !== "light";

  }


  if (moon) {

    moon.hidden =
      nextTheme !== "dark";

  }


  if (label) {

    label.textContent =
      nextTheme === "light"
        ? "Light Mode"
        : "Dark Mode";

  }


  button.setAttribute(
    "aria-label",
    `Switch to ${nextTheme} mode`
  );


  button.setAttribute(
    "title",
    `Switch to ${nextTheme} mode`
  );


  button.setAttribute(
    "aria-pressed",
    theme === "light"
      ? "true"
      : "false"
  );

}


/* ==========================================
   UPDATE ALL TOGGLES
========================================== */

function updateThemeButtons() {

  const buttons =
    document.querySelectorAll(
      "[data-theme-toggle]"
    );


  buttons.forEach(
    updateThemeButton
  );

}


/* ==========================================
   SET THEME
========================================== */

function setSiteTheme(
  theme
) {

  const normalizedTheme =
    theme === "light"
      ? "light"
      : "dark";


  const currentTheme =
    getSiteTheme();


  if (
    currentTheme ===
    normalizedTheme
  ) {

    updateThemeButtons();

    return;

  }


  document.documentElement
    .dataset.theme =
      normalizedTheme;


  try {

    localStorage.setItem(
      "site-theme",
      normalizedTheme
    );

  } catch (error) {

    /*
      Theme still works if
      localStorage is unavailable.
    */

  }


  updateThemeButtons();


  /*
    Theme-aware components such as
    Apple Music can react to this.
  */

  document.dispatchEvent(
    new CustomEvent(
      "site:themechange",
      {
        detail: {
          theme:
            normalizedTheme
        }
      }
    )
  );

}


/* ==========================================
   TOGGLE THEME
========================================== */

function toggleSiteTheme() {

  const currentTheme =
    getSiteTheme();


  setSiteTheme(
    currentTheme === "dark"
      ? "light"
      : "dark"
  );

}


/* ==========================================
   INITIALIZE TOGGLE BUTTONS
========================================== */

function initThemeToggle(
  root = document
) {

  const buttons =
    root.querySelectorAll(
      "[data-theme-toggle]"
    );


  buttons.forEach(
    (button) => {

      if (
        button.dataset.themeInitialized ===
        "true"
      ) {
        return;
      }


      button.dataset.themeInitialized =
        "true";


      button.addEventListener(
        "click",
        toggleSiteTheme
      );


      updateThemeButton(
        button
      );

    }
  );

}


/* ==========================================
   GLOBAL API
========================================== */

window.siteTheme = {
  get:
    getSiteTheme,

  set:
    setSiteTheme,

  toggle:
    toggleSiteTheme,

  refresh:
    updateThemeButtons
};


/* ==========================================
   PAGE LOAD
========================================== */

document.addEventListener(
  "DOMContentLoaded",
  () => {

    initThemeToggle();

    updateThemeButtons();

  }
);


/* ==========================================
   SHOPIFY THEME EDITOR
========================================== */

document.addEventListener(
  "shopify:section:load",
  (event) => {

    initThemeToggle(
      event.target
    );


    updateThemeButtons();

  }
);


/*
  Also initialize immediately in case
  the script executes after DOMContentLoaded.
*/

initThemeToggle();

updateThemeButtons();